const AppRotas = {
    HOME: '/',
    AREA_ALUNO: '/aluno/:chave',
    SOBRE: '/sobre',
    CONTATO: '/contato',
    ADMIN: '/admin'
}
export default AppRotas;